module.exports = __webpack_public_path__ + "static/img/50-2.c8d6be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/50-2.jpg
// module id = Z558
// module chunks = 0